import React from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';

import Icon from '../Icon/Icon';
import Text from '../Text/Text';
import {
  StyledTooltipWrapper,
  StyledActiveContainer,
  StyledIconContainer,
  StyledTitleContainer,
  StyledTooltipContent,
  StyledChildContainer,
} from './Tooltip.styled';
import { ComponentProps as Props } from './Tooltip.types';

const Tooltip: React.FC<Props> = ({
  children,
  id,
  message,
  messageType,
  tooltipPlacement = 'right',
  tooltipStyle,
  tooltipProps,
  title,
  titleType,
  withArrow = false,
  optionalIconProps,
  ...styleProps
}) => {
  return (
    <>
      <StyledTooltipWrapper {...styleProps}>
        <StyledChildContainer {...styleProps}>{styleProps.showIcon && children}</StyledChildContainer>
        <StyledActiveContainer {...styleProps} data-tooltip-id={id} data-testid={`tooltipHover-${id}`}>
          {getHoverItem(styleProps.showIcon, optionalIconProps, styleProps, children, id)}
        </StyledActiveContainer>
      </StyledTooltipWrapper>
      <ReactTooltip
        id={id}
        place={tooltipPlacement}
        style={{
          backgroundColor: 'var(--color-vibrant-blue-t10)',
          textColor: 'var(--color-indigo-t11)',
          zIndex: 1000,
          opacity: 1,
          ...tooltipStyle,
        }}
        offset={10}
        noArrow={!withArrow}
        {...tooltipProps}>
        {getHoverContent(styleProps, title, titleType, message, messageType, id)}
      </ReactTooltip>
    </>
  );
};

const getHoverItem = (showIcon, optionalIconProps, styleProps, children, id) =>
  showIcon ? (
    <StyledIconContainer {...styleProps}>
      <Icon type="additionalInfo" color="var(--color-vibrant-blue-t10)" {...optionalIconProps} />
    </StyledIconContainer>
  ) : (
    children
  );

const getHoverContent = (styleProps, title, titleType, message, messageType, id) => (
  <StyledTooltipContent {...styleProps} data-testid={`tooltipContent-${id}`}>
    {title && (
      <StyledTitleContainer {...styleProps}>
        {typeof title === 'string' ? (
          <Text size="normal" variant="secondary" weight="bold" {...titleType}>
            {title}
          </Text>
        ) : (
          title
        )}
      </StyledTitleContainer>
    )}
    {typeof message === 'string' ? (
      <Text size="normal" variant="secondary" {...messageType}>
        {message}
      </Text>
    ) : (
      message
    )}
  </StyledTooltipContent>
);

export default Tooltip;
